export default __webpack_public_path__ + "static/media/play_white.1c341903.svg";